<app-kiosk-spinner></app-kiosk-spinner>

<header>
  <div class="pt-2" style="position: relative">
    <img src="assets/img/assurcard-logo.svg" class="logo" alt="AssurCard logo" />
  </div>
  <mat-card class="my-2 py-0" [ngClass]="stepper?.show ? '' : 'd-none'">
    <app-stepper class="w-100" #stepper></app-stepper>
  </mat-card>
</header>